export default function SendToTechnicalDifficulties(errorMessage) {
	console.error(`Technical difficulties:  ${errorMessage}`);
	window.location.replace(
		`${process.env.REACT_APP_WEBSITE_URL}apps/prequal/downtime-error`,
	);
}
